import React, { PureComponent } from 'react';
import LocationSvg from '../../../shared/UI/locationSvg';
import { itineraryListData } from '../../../../helpers/itineraryHelper';
import { connect } from 'react-redux';
import { ampmConvert } from '../../../../helpers/utils';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(AdvancedFormat);

class MeetingPointPanel extends PureComponent {

    renderArriveDepartList(){

        const { currentStop, totalStops, _itinerary } = this.props;
        const {
          dateDurationStart,
          dateDurationEnd,
          city, 
          nextCity, 
          arriveTime, 
          nextDepartureTime, 
          nextType, 
          previousType
        } = itineraryListData(currentStop, _itinerary);
        
        //Show/hide arrival or departure info for gap and next gap sector
        const _isNextGap = (_itinerary[currentStop].type === "city" && _itinerary[currentStop < _itinerary.length -1  ? currentStop + 1 : 0].type === "start") ? true : false;
        const _isGap = (_itinerary[currentStop].type === "start") ? true : false;

        if(currentStop === 0){
          return <li><span className="bold mr2">{dateDurationStart} at {ampmConvert(nextDepartureTime)}</span> Departing in {city}</li>
        }
        if(currentStop > 0 && currentStop <  totalStops-1){
          return (
            <>
              { (previousType !== "product" && !_isGap) && <li><span className="bold mr2">{dateDurationStart} at {ampmConvert(arriveTime)}</span> Arriving in {city}</li> }
              { (nextType !== "product" && !_isNextGap) && <li><span className="bold mr2">{dateDurationEnd.split("- ")[1]} at {ampmConvert(nextDepartureTime)}</span> Departing for {nextCity}</li> }
            </>
          )
        }else{
          return <li><span className="bold mr2">{dateDurationStart} at {ampmConvert(arriveTime)}</span> Arriving in {city}</li>
        }
    
    }


    render(){

        const { _itinerary, currentStop } = this.props;
        const { 
            type:_type,
            hostelName:_hostelName,
            address:_address,
            city:_city,
            country:_country,
            arriveTime,
            departTime,
            productStartAddress,
            productEndAddress,
            date,
            nights
          } = itineraryListData(currentStop, _itinerary); 

        return (
            <div className="clearfix">
            <div className="col col-1"><LocationSvg fill="currentColor" /></div>
            <div className="col col-11">
              <p className="medium mb1">{_type !== "product" ? "Coach Meeting Point" : "Meeting Point"}</p> 

              {
                  _type !== "product" && (
                    <>  
                    <p className="bold">{_hostelName}</p>
                    <p className="f-size-12 agent-portal-grey margin-b-30">{_address}  {_city}, {_country}</p>
                    </>
                  )
              } 

            
              <ul className={`arrive-depart-list ${_type === "product" ? 'product': ''}`}>

                { (_itinerary !== undefined && _type !== "product") && this.renderArriveDepartList() }

                { 
                    (_itinerary !== undefined && _type === "product") && (
                        <>
                            <li>
                                <span className="bold mr2">Start - {dayjs(date).format("D MMMM YYYY")} at {departTime}</span><br/>
                                <span className="f-size-14 agent-portal-grey margin-b-30">{productStartAddress}</span>
                            </li>
                            <li>
                                <span className="bold mr2">End - {dayjs(date).add(nights,'days').format("D MMMM YYYY")} at {arriveTime}</span><br />
                                <span className="f-size-14 agent-portal-grey margin-b-30">{productEndAddress}</span>
                            </li>
                        </>
                    )
                }
              </ul>
            
            </div>
          </div>            
        )
    }

}


const mapStateToProps = state => {
    return{
      _itinerary:state.currentBooking.filteredItinerary
    }
}

export default connect(mapStateToProps, null)(MeetingPointPanel); 
  